import React from 'react';
import { shuffle } from 'lodash';

import {
  getColorTokensWithClustering,
  getColorTokensWithDeltaE,
} from '@neptune/colors-business-logic';
import { ColorToken, HEXColor } from '@neptune/colors-domain';

import { useRunsColorsContext } from './runs-colors-context';

const DEFAULT_COLORS = new Map();

export function useColorsGenerator({
  initialColors = DEFAULT_COLORS,
  workspaceName,
  projectName,
}: {
  initialColors?: Map<string, ColorToken | HEXColor>;
  workspaceName?: string;
  projectName?: string;
}) {
  const { setColors, makeColorKey } = useRunsColorsContext();

  return React.useCallback(
    (keys: string[]) => {
      if (!workspaceName || !projectName) {
        return;
      }

      let tokens: ColorToken[] = [];

      const colorKeys = keys.map((key) => makeColorKey(workspaceName, projectName, key));

      if (colorKeys.length < 4) {
        tokens = getColorTokensWithDeltaE(Array.from(initialColors.values()), keys.length);
      } else {
        tokens = getColorTokensWithClustering(Array.from(initialColors.values()), keys.length);
      }

      tokens = shuffle(tokens);

      const result = new Map();

      for (let i = 0; i < colorKeys.length; i++) {
        result.set(colorKeys[i], tokens[i]);
      }

      setColors(result);
    },
    [workspaceName, projectName, setColors, makeColorKey, initialColors],
  );
}
